import "./styles/default.less"

import * as React from "react"
import * as ReactDOM from "react-dom"
import * as flat from "flat"
import * as mockxhr from "mockxhr"
import * as qs from "query-string"
import { get, set } from "object-path"
import * as _ from "lodash"

import * as magazine from "./misc/magzine"
import * as util from "./util"
import PopularAndLatest from "./components/PopularAndLatest"
import AdRight from "./components/AdRight"
import Filter from "./components/Filter"
import Footer from "./components/Footer2"
import Header from "./components/Header4"
import Search from "./components/Search"
import { Box, Item, Button } from "./components"
import { actions, API } from "./flux"

interface Props {
}

interface State {
    filters: any
    _filters: any
    from: number
    size: number
    query: string
    type: string
    jobs: any[]
    employers: any
    magazine: any
    hideLoadMore: boolean
    formatList: string[]
    recruitSubjects: subject[]
    offlineSubjects: subject[]
}

interface subject {
    text: string
    value: string
    promotionId: number
}

class View extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        let params = qs.parse(location.search)
        this.state = {
            filters: { online: true },
            _filters: {},
            from: 0,
            size: 20,
            query: "",
            type: "LATEST",
            jobs: [],
            employers: {},
            magazine: {
                issue: get(params, "magazine.issue"),
                jobs: [],
            },
            hideLoadMore: false,
            formatList: ['homeWeightPaper', 'homeWeightRecruit', 'weightCareer', 'weightPaper', 'weightNews', 'weightRecruit'],
            recruitSubjects: [],
            offlineSubjects: [],
        }
        this.dataFormat = this.dataFormat.bind(this)

        Object.keys(params).forEach(key => {
            // 微信转发会添加 from=singlemessage/timeline/...
            if (key === "from" && isNaN(parseInt(params[key]))) return
            set(this.state, key, decodeURIComponent(params[key]))
        })
    }

    componentDidMount() {
        mockxhr.GET("/api/promotions/searchFilters", {}, resp => {
            resp.forEach(x => {
                set(this.state._filters, `${x.type1}.${x.type2}.${x.title}`, x)
                set(this.state._filters, `undefined.${x.type2}.${x.title}`, x)
            })
            this.setState({})
        })
        mockxhr.POST("/api/subject/do?from=0&size=10&type=SEARCH", {
            exportFilter: [],
            query: "",
            subjectDao: {subjectName: ""},
            type: "SEARCH",
        }, ({ hits }) => {
            let arr = _.sortBy(_.filter(_.map(_.filter(hits, i => i.subjectName !== "其他"), j => this.dataFormat(j)), k => k._weightRecruit === 0 && k.weightRecruit !== 0), o => o.weightRecruit)
            let offlineArr = _.sortBy(_.filter(_.map(_.filter(hits, i => i.subjectName !== "其他"), j => this.dataFormat(j)), k => k._weightRecruit === 0 && k.weightRecruit === 0), o => o.weightRecruit)
            let recruitSubjects = _.map(arr, i => ({
                text: i.subjectName,
                value: i.subjectName,
                promotionId: i.id,
            }))
            let offlineSubjects = _.map(offlineArr, i => ({
                text: i.subjectName,
                value: i.subjectName,
                promotionId: i.id,
            }))
            this.setState({ recruitSubjects, offlineSubjects })
        })
        this.search()

        if (this.state.magazine.issue && magazine.issues[this.state.magazine.issue]) {
            let { jobs } = magazine.issues[this.state.magazine.issue]
            jobs.forEach((id, i) => {
                actions.api.job.get({ id }, res => {
                    this.state.magazine.jobs[i] = res
                    this.setState({})
                })
            })
        }
    }

    search(redirect = false, isMore = false) {
        if (redirect) {
            let queryParams = flat({
                query: this.state.query,
                filters: Object.keys(this.state.filters).length ? this.state.filters : undefined,
            })
            if (queryParams["filters.employerType"] !== "COLLEGE") {
                delete queryParams["filters.subjects"]
                delete queryParams["filters.name"]
                delete queryParams["filters.talentPlans"]
            }
            if (queryParams["filters.employerType"] !== "OTHER") {
                delete queryParams["filters.classification"]
                delete queryParams["filters.industries"]
            }
            setTimeout(() => location.search = qs.stringify(queryParams), 500)
            return
        } 
        // 选择博士时不匹配博士后
        if (this.state.filters && this.state.filters.name === "博士") {
            set(this.state, "filters.-name", "博士后")
        } else {
            set(this.state, "filters.-name", null)
        }
        
        if(!isMore) {
            // 初次加载
            set(this.state, "filters.onlineTime", null)
            actions.api.job.search({
                from: 0,
                size: this.state.size,
                filters: this.state.filters,
                query: this.state.query,
                type: this.state.type,
                sort: [],
            }, resp => {
                this.setState({
                    hideLoadMore: resp.hits.length < this.state.size || resp.total === 0,
                    from: resp.hits.length,
                    jobs: resp.hits,
                })
            })
        } else {
            // 加载更多
            set(this.state, "filters.onlineTime", this.state.jobs[this.state.jobs.length - 1].onlineTime)
            actions.api.job.search({
                from: this.state.from,
                size: this.state.size,
                filters: this.state.filters,
                query: this.state.query,
                type: this.state.type,
                sort: [],
            }, resp => {
                let newFrom = this.state.from
                this.setState({
                    hideLoadMore: resp.hits.length < this.state.size,
                    from: newFrom + resp.hits.length,
                    jobs: util.mergeArrayById(this.state.jobs, resp.hits),
                })
            })
        }
        
    }

    job(item: any) {
        let employer = this.state.employers[item.employerId]
        if (!employer) {
            this.state.employers[item.employerId] = employer = {}
            mockxhr.GET(API.employer.one(item.employerId), {}, resp => {
                this.state.employers[item.employerId] = resp
                this.setState({})
            }, () => { })
        }

        let labelStyle = {
            borderRadius: 999, color: "#999", fontSize: ".75rem", background: "white",
            marginRight: "1em", lineHeight: 2, border: "1px solid #eee", padding: "0 1em",
            display: "inline-block", cursor: "pointer",
        }

        return (
            <div className="line-height box-shadow" style={{ marginTop: "1.25rem" }}>
                <Box style={{ padding: "1.25rem" }}>
                    <Box flex>
                        <a href={`/jobs/${item.id}`} target="_blank">
                            <div
                                style={{
                                    height: "5rem",
                                    minWidth: "5rem",
                                    backgroundImage: `url(${employer.logo})`,
                                    backgroundSize: "contain",
                                    backgroundPosition: "center center",
                                    backgroundColor: "white",
                                    backgroundRepeat: "no-repeat",
                                    border: "1px solid #e5e5e5",
                                }} />
                        </a>
                        {util.minWidth("1.25rem")}
                        <a href={`/jobs/${item.id}`} target="_blank" style={{ color: "inherit" }}>
                            <Box vertical justified flex style={{ height: "5rem", lineHeight: 1.2 }}>
                                <div className="ellipsis" style={{ width: "28rem", fontWeight: 700 }}>
                                    {util.fullEmployerName(employer.name, item.department)}
                                </div>
                                <div className="ellipsis text-primary" style={{ color: "#333", width: "28rem", lineHeight: 1.2 }}>
                                    {util.jobNameWithTalentPlans(item.name, item.talentPlans)}
                                </div>
                                <div className="ellipsis text-gray"
                                    style={{ fontSize: ".85rem", width: "28rem", lineHeight: 1.2 }}>
                                    {util.researchFields(item)}
                                </div>
                            </Box>
                        </a>
                    </Box>
                    {util.minWidth("1.25rem")}
                    <Box vertical justified style={{ width: "10rem", fontSize: ".85rem" }}>
                        <div className="text-primary">{util.salaryText(item)}</div>
                        <div className="text-gray">{item.minDegree}</div>
                        <div className="text-gray ellipsis">{item.city}</div>
                    </Box>
                </Box>
                <Box center style={{ padding: "0 1.25rem", height: "2.5rem", background: "#f9f9f9" }}>
                    <Item flex className="pre-wrap" style={{ overflow: "hidden", height: 26 }}>
                        {item.classification ?
                            <div style={labelStyle}
                                onClick={() => location.href = "/search?filters.employerType=OTHER&filters.classification=" + encodeURIComponent(item.classification)}>
                                {item.classification}
                            </div>
                            : null
                        }
                        {(item.subjects || []).filter(x => !!x).map(tag =>
                            <div style={labelStyle}
                                onClick={() => location.href = "/search?filters.employerType=COLLEGE&filters.subjects=" + encodeURIComponent(tag)}>
                                {tag}
                            </div>
                        )}
                    </Item>
                    {util.minWidth("1.25rem")}
                    <Box center style={{ width: "10rem", fontSize: ".75rem" }}>
                        <div className="text-minor">
                            {util.formatTs(item.onlineTime, "%Y/%m/%d")}
                        </div>
                    </Box>
                </Box>
            </div>
        )
    }

    getOptions(group) {
        return Object.keys(group).map(key => {
            return {
                text: key,
                value: key,
                promotionId: group[key].id,
            }
        })
    }

    dataFormat(parm) {
        let obj = {}
        _.forEach(parm, (item, index) => {
            if (_.indexOf(this.state.formatList, index) < 0) {
                obj[index] = item
            } else {
                obj[index] = parseInt(Object.keys(item)[0], 10)
                obj[`_${index}`] = parseInt(item[Object.keys(item)[0]], 10)
            }
        })
        return obj
    }

    render() {
        let that = this
        let filterKeys: any[]

        let employerTypeFilter = {
            text: "单位类型",
            key: "employerType",
            options: [
                { value: "COLLEGE", text: "高校/研究机构" },
                { value: "OTHER", text: "企业" },
            ],
            noMore: true,
        }

        if (this.state.filters.employerType === "COLLEGE") {
            filterKeys = [{
                ...employerTypeFilter
            }, {
                text: "工作地点",
                key: "region",
                options: that.getOptions(get(this.state._filters, "COLLEGE.region", {})),
                noMore: true,
                subKey: "city",
                fetchSubOptions(value, callback) {
                    mockxhr.GET(`/api/promotions/searchFilters/COLLEGE/region/${value}`, {}, resp => {
                        callback(resp.map(r => ({ promotionId: r.id, value: r.title, text: r.title })))
                    })
                }
            }, {
                text: "工作经验",
                key: "experience",
                options: this.getOptions(get(this.state._filters, "COLLEGE.experience", {})),
                noMore: true,
            }, {
                text: "学历要求",
                key: "minDegree",
                options: this.getOptions(get(this.state._filters, "COLLEGE.minDegree", {})),
                noMore: true,
            }, {
                text: "职位性质",
                key: "form",
                options: this.getOptions(get(this.state._filters, "COLLEGE.form", {})),
                noMore: true,
            }, {
                text: "职位名称",
                key: "name",
                options: this.getOptions(get(this.state._filters, "COLLEGE.name", {})),
                noMore: true,
            }, {
                text: "人才计划",
                key: "talentPlans",
                options: this.getOptions(get(this.state._filters, "COLLEGE.talentPlans", {})),
                noMore: true,
            }, {
                text: "所属学科",
                key: "subjects",
                // options: this.getOptions(get(this.state._filters, "COLLEGE.subjects", {})),
                options: this.state.recruitSubjects,
                offlineOptions: this.state.offlineSubjects,
                subKey: "researchFields",
                noMore: true,
                // fetchSubOptions(value, callback) {
                //     mockxhr.GET(`/api/promotions/searchFilters/COLLEGE/subjects/${value}`, {}, resp => {
                //         callback(resp.map(r => ({ promotionId: r.id, value: r.title, text: r.title })))
                //     })
                    // mockxhr.POST("/api/subject/do?from=0&size=10&type=SEARCH", {
                    //     exportFilter: [],
                    //     query: "",
                    //     subjectDao: {subjectName: ""},
                    //     type: "SEARCH",
                    // }, ({ hits }) => {
                    //     let arr = _.sortBy(_.filter(_.map(_.filter(hits, i => i.subjectName !== "其他"), j => that.dataFormat(j)), k => k._weightRecruit === 0), o => o.weightRecruit)
                    //     callback(_.map(arr, i => ({ promotionId: i.id, value: i.subjectName, text: i.subjectName })))
                    // })
                // }
            }]
        } else if (this.state.filters.employerType === "OTHER") {
            filterKeys = [{
                ...employerTypeFilter
            }, {
                text: "工作地点",
                key: "region",
                options: this.getOptions(get(this.state._filters, "OTHER.region", {})),
                noMore: true,
                subKey: "city",
                fetchSubOptions(value, callback) {
                    mockxhr.GET(`/api/promotions/searchFilters/OTHER/region/${value}`, {}, resp => {
                        callback(resp.map(r => ({ promotionId: r.id, value: r.title, text: r.title })))
                    })
                }
            }, {
                text: "工作经验",
                key: "experience",
                options: this.getOptions(get(this.state._filters, "OTHER.experience", {})),
                noMore: true,
            }, {
                text: "学历要求",
                key: "minDegree",
                options: this.getOptions(get(this.state._filters, "OTHER.minDegree", {})),
                noMore: true,
            }, {
                text: "职位性质",
                key: "form",
                options: this.getOptions(get(this.state._filters, "OTHER.form", {})),
                noMore: true,
            }, {
                text: "职位类型",
                key: "classification",
                options: this.getOptions(get(this.state._filters, "OTHER.classification", {})),
                noMore: true,
            }, {
                text: "所属行业",
                key: "industries",
                options: this.getOptions(get(this.state._filters, "OTHER.industries", {})),
                noMore: true,
            }]
        } else {
            filterKeys = [{
                ...employerTypeFilter
            }, {
                text: "工作地点",
                key: "region",
                options: this.getOptions(get(this.state._filters, "undefined.region", {})),
                noMore: true,
                subKey: "city",
                fetchSubOptions(value, callback) {
                    mockxhr.GET(`/api/promotions/searchFilters/undefined/region/${value}`, {}, resp => {
                        let cities = {}
                        resp.forEach(x => cities[x.title] = cities[x.title] || x)
                        callback(
                            Object.keys(cities).map(k => cities[k]).sort((a, b) => b.weight - a.weight)
                                .map(r => ({ promotionId: r.id, value: r.title, text: r.title }))
                        )
                    })
                }
            }, {
                text: "工作经验",
                key: "experience",
                options: this.getOptions(get(this.state._filters, "undefined.experience", {})),
                noMore: true,
            }, {
                text: "学历要求",
                key: "minDegree",
                options: this.getOptions(get(this.state._filters, "undefined.minDegree", {})),
                noMore: true,
            }, {
                text: "职位性质",
                key: "form",
                options: this.getOptions(get(this.state._filters, "undefined.form", {})),
                noMore: true,
            }]
        }

        return (
            <Box vertical className="min-view">
                <Header tab="JOB" search="jobs" style={{maxWidth: '1180px', minWidth: '1180px'}} />
                <Search placeholder="输入搜索关键词"
                    defaultValue={this.state.query} ref="search"
                    onClick={q => this.setState({ from: 0, jobs: [], query: q }, () => this.search(true))} />

                <Item relative>
                    <Box centerJustified>
                        <Item relative style={{ width: "100%" }}>
                            <Box centerJustified>
                                <Item relative className="fix-view">
                                    <Filter 
                                        ref="filter" 
                                        defaultSelected={this.state.filters}
                                        onChange={filters => this.setState({ filters }, () => this.search(true))}
                                        keys={filterKeys} />
                                </Item>
                            </Box>

                            {util.minHeight("1.25rem")}
                            <Box centerJustified style={{ padding: "1.25rem 0 2.5rem", background: "#f4f4f4" }}>
                                <Item style={{ width: "50rem" }}>
                                    <PopularAndLatest
                                        onClick0={() => {
                                            this.setState({ from: 0, jobs: [], type: "LATEST" }, () => this.search())
                                        }} onClick1={() => {
                                            this.setState({ from: 0, jobs: [], type: "OVERALL" }, () => this.search())
                                        }} />
                                    {[...this.state.magazine.jobs, ...this.state.jobs].filter(j => !!j).map(j => this.job(j))}
                                    {(this.state.magazine.jobs.length || this.state.jobs.length) ? null : util.empty(
                                        "更多职位正在努力上传中，请保持关注~",
                                        { background: "white", marginTop: "1.25rem" },
                                        "box-shadow"
                                    )}
                                    { (this.state.magazine.jobs.length || this.state.jobs.length) ? !this.state.hideLoadMore &&
                                        <div style={{ marginTop: "1.25rem" }}>
                                            <Button primary fluid style={{ borderRadius: 1 }}
                                                onClick={() => this.search(false, true)}>
                                                加载更多
                                            </Button>
                                        </div>
                                        :
                                        null
                                    }
                                </Item>

                                {util.minWidth("5rem")}

                                <AdRight />
                            </Box>
                        </Item>
                    </Box>
                </Item>

                <Footer />
            </Box>
        )
    }
}

ReactDOM.render(<View />, document.body.firstChild as any)
